import React from 'react';
import svgPaths from './svgs';

export default function Vector(): React.JSX.Element {
  return (
    <div className="relative size-full" data-name="Vector">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 112 25">
        <g id="Vector">
          <path d={svgPaths.p1d5e1d00} fill="var(--fill-0, black)" />
          <path d={svgPaths.p1b99a980} fill="var(--fill-0, black)" />
          <path d={svgPaths.p1c410600} fill="var(--fill-0, black)" />
          <path d={svgPaths.p14f1d540} fill="var(--fill-0, black)" />
          <path d={svgPaths.p1194a00} fill="var(--fill-0, black)" />
          <path d={svgPaths.p15562380} fill="var(--fill-0, black)" />
          <path d={svgPaths.p3cba6700} fill="var(--fill-0, black)" />
          <path d={svgPaths.p11a45540} fill="var(--fill-0, black)" />
          <path d={svgPaths.p24708c40} fill="var(--fill-0, black)" />
          <path d={svgPaths.p3da36c80} fill="var(--fill-0, black)" />
          <path d={svgPaths.p2d5b0200} fill="var(--fill-0, black)" />
          <path d={svgPaths.p2a97ea00} fill="var(--fill-0, black)" />
          <path d={svgPaths.pb48e200} fill="var(--fill-0, black)" />
          <path d={svgPaths.p267e8c80} fill="var(--fill-0, black)" />
          <path d={svgPaths.p3af45000} fill="var(--fill-0, black)" />
          <path d={svgPaths.p2eebf900} fill="var(--fill-0, black)" />
          <path d={svgPaths.p2cdf3b80} fill="var(--fill-0, black)" />
          <path d={svgPaths.p363b0f40} fill="var(--fill-0, black)" />
          <path d={svgPaths.p366ab580} fill="var(--fill-0, black)" />
          <path d={svgPaths.p43fd80} fill="var(--fill-0, black)" />
          <path d={svgPaths.p1ff0e680} fill="var(--fill-0, black)" />
          <path d={svgPaths.p130e3b30} fill="var(--fill-0, black)" />
          <path d={svgPaths.p2e1b8700} fill="var(--fill-0, black)" />
          <path d={svgPaths.p2a08f080} fill="var(--fill-0, black)" />
          <path d={svgPaths.p38058b00} fill="var(--fill-0, black)" />
          <path d={svgPaths.p95c6760} fill="var(--fill-0, black)" />
          <path d={svgPaths.p26f2fd00} fill="var(--fill-0, black)" />
          <path d={svgPaths.p1dbee1c0} fill="var(--fill-0, black)" />
          <path d={svgPaths.p2c7c3200} fill="var(--fill-0, black)" />
        </g>
      </svg>
    </div>
  );
}
